import { IBaseDisbursementStatusPill } from '../IBaseDisbursementStatusPill';
import { assertValueIsOfType } from 'utilities/Assertions';
import React from 'react';
import { IInternalTransferDisbursementFormData } from 'types/order/escrow/internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { getDateString, DateFormat } from '../../../../../../ui-toolkit/utilities/getDateString';
import { BaseStatusPill } from '../shared/BaseStatusPill';

const getPillDetails = (internalTransfer: IInternalTransferDisbursementFormData) => {
  switch (true) {
    case !!internalTransfer.voidedAt:
      return 'Void';
    case !!internalTransfer.completedAt:
      return 'Disbursed';
    case !!internalTransfer.enqueuedForDisbursementAt:
      return 'Initiated';
    case !!internalTransfer.holdback:
      return 'Holdback';
    default:
      return 'Staged';
  }
};

export const InternalTransferStatusPill: React.FC<IBaseDisbursementStatusPill> = ({ disbursement, amountMismatch }) => {
  assertValueIsOfType<IInternalTransferDisbursementFormData>(
    disbursement,
    () => disbursement.type === 'Internal Transfer',
    `I was supposed to only be passed an internal transfer and I was passed a ${disbursement.type} instead`
  );

  const status = getPillDetails(disbursement);
  const dateForTooltip = disbursement.completedAt ?? disbursement.enqueuedForDisbursementAt;
  const dateDisplay = dateForTooltip ? getDateString(DateFormat.short, dateForTooltip) : undefined;
  return (
    <BaseStatusPill
      status={status}
      text={'Internal'}
      amountCents={disbursement.amountCents}
      id={disbursement.id}
      title={dateDisplay}
      hasWarning={amountMismatch}
    />
  );
};
